export default "__VITE_PUBLIC_ASSET__cbaf1d94__"